import React from "react";
import "./moderatorSection.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

const setting = {
  dots: true,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1.2,
  slidesToScroll: 1,
  initialSlide: 0,
};

const ModeratorSection = (props: ReferenciaContenido) => {
  const data = props;
  return (
    <div className="m-moderator">
      <div className="center">
        <div className="m-moderator__title">
          <h2>{data?.tituloGeneral}</h2>
        </div>
      </div>

      <div className="m-moderator__cards hide-on-mobile">
        {data?.referenciaPlantillaContenido.map((s, idx) => {
          return (
            <div className="m-moderator__cards__elem" key={`key: ${idx}`}>
              <div className="m-moderator__cards__elem__face">
                <img
                  src={
                    s?.imagenPerfil
                      ? s.imagenPerfil.file?.url
                      : s.imagenPrincipal[0]?.file?.url
                  }
                  alt={
                    s?.imagenPerfil
                      ? s.imagenPerfil.file?.fileName
                      : s.imagenPrincipal[0]?.title
                  }
                />
              </div>
              <div className="m-moderator__cards__elem__info">
                <div className="m-moderator__cards__elem__info__name">
                  <h3>{s?.tituloBanner}</h3>
                </div>
                <div className="m-moderator__cards__elem__info__spec">
                  <p>{s?.tituloDescripcion}</p>
                </div>
                <div className="m-moderator__cards__elem__info__desc">
                  <p>
                    {
                      JSON.parse(s?.descripcion.raw)?.content[0]?.content[0]
                        ?.value
                    }
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="m-moderator__cards show-on-mobile">
        <Slider {...setting}>
          {data?.referenciaPlantillaContenido.map((s, idx) => {
            return (
              <div key={`key: ${idx}`}>
                <div className="m-moderator__cards__elem">
                  <div className="m-moderator__cards__elem__face">
                    <img
                      src={
                        s?.imagenPerfil
                          ? s.imagenPerfil.file?.url
                          : s.imagenPrincipal[0]?.file?.url
                      }
                      alt={
                        s?.imagenPerfil
                          ? s.imagenPerfil.file?.fileName
                          : s.imagenPrincipal[0]?.title
                      }
                    />
                  </div>
                  <div className="m-moderator__cards__elem__info">
                    <div className="m-moderator__cards__elem__info__name">
                      <h3>{s?.tituloBanner}</h3>
                    </div>
                    <div className="m-moderator__cards__elem__info__spec">
                      <p>{s?.tituloDescripcion}</p>
                    </div>
                    <div className="m-moderator__cards__elem__info__desc">
                      <p>
                        {
                          JSON.parse(s?.descripcion?.raw)?.content[0]
                            ?.content[0]?.value
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default ModeratorSection;
